<template>
  <carousel :items-to-show="7" :autoplay="3000" :wrap-around="true" class="w-full">
    <slide v-for="skill of skills" :key="skill.name">
      <skill-item :skill="skill"></skill-item>
    </slide>
  </carousel>
</template>
<script>
import { skills } from '@/data/works';

import { Carousel, Slide } from 'vue3-carousel';
import 'vue3-carousel/dist/carousel.css';
import SkillItem from '@/views/about/carousel/SkillItem.vue';

export default {
  name: 'CarouselSkill',
  data() {
    return {
      skills,
    };
  },
  components: {
    Carousel,
    Slide,
    SkillItem,
  },
};
</script>
